import { Box, type BoxProps } from '@mui/material'

type BrandLogoProps = {
  /** Tamanho da letra em px. */
  size?: number
} & Omit<BoxProps, 'component' | 'children'>

/**
 * Marca da suíte em texto — "HUB" na cor principal do tema.
 * Quando existir o logo oficial, trocar o conteúdo por <img> sem mexer em quem usa.
 */
export function BrandLogo({ size = 22, sx, ...rest }: BrandLogoProps) {
  return (
    <Box
      {...rest}
      component="span"
      role="img"
      aria-label="MarketingHUB"
      sx={{
        fontFamily: '"Outfit", sans-serif',
        fontSize: size,
        lineHeight: 1,
        letterSpacing: '-0.01em',
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        alignItems: 'baseline',
        flexShrink: 0,
        ...sx,
      }}
    >
      <Box component="span" sx={{ fontWeight: 500 }}>
        Marketing
      </Box>
      <Box component="span" sx={{ fontWeight: 700, color: 'primary.main' }}>
        HUB
      </Box>
    </Box>
  )
}
